const mutation = {
  SET_ALL_CONTRACTS(state, contractVendors) {
    state.contractVendors = contractVendors;
  },

  SET_CONTRACTS_LOADING(state, status) {
    state.isContractLoading = status;
  },

  MATRIX_DATA(state, data) {
    state.all = data;
  },

  MATRIX_LOADING(state, status) {
    state.isMatrixLoading = status;
  },

  SET_ALL_OPENVENDOR(state, openVendors) {
    state.openVendors = openVendors;
  },
  SET_ALL_OPENVEHICLES(state, openVendors) {
    state.openVehicles = openVendors;
  },
};

export default mutation;
